import { App, Button, Spin, Table } from "antd"
import { useEffect, useState } from "react";
import { availableCheckInColumns, bookedColumns, useGetProgramBookingCheckInAdminByMemberMobileAndStatusAndTargetDateTimeIsNotBeforeNow, useGetProgramBookingCheckInAdminByProgramBookingIdAndStatusAndTargetDateTimeIsNotBeforeNow, useUpdateProgramBookingStatusAdminByUpdateProgramBookingStatusRequest } from "./model";
import { EProgramBookingStatus } from "../../wellnessProgram/program/booking/model";

interface IProps {
    targetMobile: string
    isOnClickRequestBtn: boolean
    setIsOnClickRequestBtn: React.Dispatch<React.SetStateAction<boolean>>
    programBookingId?: number;
    setProgramBookingId?: React.Dispatch<React.SetStateAction<number | undefined>>
}

const CheckInProgram = ({ targetMobile, isOnClickRequestBtn, setIsOnClickRequestBtn, programBookingId, setProgramBookingId }: IProps) => {
    const [selectedProgramRowKeys, setSelectedProgramRowKeys] = useState<React.Key[]>([]);
    const { data, isFetching, refetch } = useGetProgramBookingCheckInAdminByMemberMobileAndStatusAndTargetDateTimeIsNotBeforeNow(targetMobile, EProgramBookingStatus.COMPLETE)
    const { data: dataV2, isFetching: isFetchingV2 } = useGetProgramBookingCheckInAdminByProgramBookingIdAndStatusAndTargetDateTimeIsNotBeforeNow(programBookingId)
    const [autoCheckInProgram, setAutoCheckInProgram] = useState<IProgramBookingCheckInAdminResponseItem[]>([])
    const [memberData, setMemberData] = useState<{ name?: string, mobile?: string } | undefined>({ name: '', mobile: '' });
    const { message } = App.useApp();
    const updateStatus = useUpdateProgramBookingStatusAdminByUpdateProgramBookingStatusRequest();
    const onClickManualCheckIn = () => {
        const foundItem = data?.programBookingCheckInList?.find(q => selectedProgramRowKeys.includes(q.id));
        if (!foundItem || foundItem.status === EProgramBookingStatus.CHECK_IN) return;
        updateStatus.mutate({ programBookingIdList: [foundItem.id], status: EProgramBookingStatus.CHECK_IN },
            {
                onSuccess: res => {
                    if (res.data.data.updateProgramBookingStatusAdminByUpdateProgramBookingStatusRequest) {
                        message.success('체크인 성공!')
                        foundItem.status = EProgramBookingStatus.CHECK_IN;
                    }
                }
            })
    }

    useEffect(() => {
        if (!isOnClickRequestBtn) return;
        refetch();
        setIsOnClickRequestBtn(false);
    }, [isOnClickRequestBtn])

    useEffect(() => {
        if (isFetching) return setSelectedProgramRowKeys([]); setAutoCheckInProgram([]);
        setMemberData({ name: data?.memberName, mobile: data?.memberMobile })
    }, [isFetching])

    useEffect(() => {
        if (isFetchingV2 || !dataV2) return setAutoCheckInProgram([]);
        setMemberData({ name: dataV2?.memberName, mobile: dataV2?.memberMobile })
        setAutoCheckInProgram(dataV2?.programBookingCheckInList?.[0] ? [dataV2.programBookingCheckInList[0]] : [])
        setProgramBookingId?.(undefined)
        if (!dataV2?.programBookingCheckInList?.[0]?.id) return;

        updateStatus.mutate({ programBookingIdList: [dataV2?.programBookingCheckInList?.[0]?.id], status: EProgramBookingStatus.CHECK_IN },
            {
                onSuccess: res => {
                    if (res.data.data.updateProgramBookingStatusAdminByUpdateProgramBookingStatusRequest) {
                        message.success('체크인 성공!')
                        dataV2.programBookingCheckInList[0].status = EProgramBookingStatus.CHECK_IN
                        setAutoCheckInProgram(dataV2.programBookingCheckInList)
                    }
                }
            })
    }, [isFetchingV2, programBookingId])

    return <>
        <div>
            <div style={{ fontWeight: 600, fontSize: '20px', lineHeight: '28px', paddingBlock: '24px' }}>
                회원정보
            </div>
            <div style={{ display: 'flex', border: '1px solid #D9D9D9', borderRadius: '8px' }}>
                <div style={{ display: 'flex', flex: 1 }}>
                    <div style={{ flex: 1, padding: '16px', backgroundColor: '#00000005', fontWeight: 600, fontSize: '14px', lineHeight: '22px' }}>
                        이름
                    </div>
                    <div style={{ flex: 2, padding: '16px', fontSize: '14px', lineHeight: '22px' }}>
                        {memberData?.name}
                    </div>
                </div>
                <div style={{ display: 'flex', flex: 1 }}>
                    <div style={{ flex: 1, padding: '16px', backgroundColor: '#00000005', fontWeight: 600, fontSize: '14px', lineHeight: '22px' }}>
                        전화번호
                    </div>
                    <div style={{ flex: 2, padding: '16px', fontSize: '14px', lineHeight: '22px' }}>
                        {memberData?.mobile}
                    </div>
                </div>
            </div>
        </div>

        <div>
            <div style={{ fontWeight: 600, fontSize: '20px', lineHeight: '28px', paddingBlock: '24px' }}>
                예약한 프로그램<span style={{ fontWeight: 400, fontSize: '14px', lineHeight: '22px' }}>(자동체크인)</span>
            </div>
            <div style={{ border: '1px solid #D9D9D9', borderRadius: '8px', padding: '1px' }}>
                <Table loading={isFetching || isFetchingV2} dataSource={autoCheckInProgram} rowKey={'id'} columns={bookedColumns} scroll={{ y: 500 }} pagination={false} />
            </div>
        </div>

        <div>
            <div style={{ fontWeight: 600, fontSize: '20px', lineHeight: '28px', paddingBlock: '24px' }}>
                체크인 가능한 클래스
            </div>
            <div style={{ border: '1px solid #D9D9D9', borderRadius: '8px', padding: '1px' }}>
                <Table loading={isFetching || isFetchingV2} dataSource={data?.programBookingCheckInList} rowKey={'id'} columns={availableCheckInColumns} scroll={{ y: 500 }} pagination={false}
                    rowSelection={{ selectedRowKeys: selectedProgramRowKeys, onChange: (q) => setSelectedProgramRowKeys(q), type: "radio" }} />
            </div>
        </div>

        <div style={{ textAlign: 'right', paddingBlock: '24px' }}>
            <Button color="primary" variant="outlined" loading={updateStatus.isPending} disabled={selectedProgramRowKeys.length <= 0} onClick={onClickManualCheckIn}>체크인 수동 처리</Button>
        </div>
    </>
}

export default CheckInProgram